import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { pingServer } from "./services/ping";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import HomePage from "./pages/HomePage";
import QuoteStartPage from "./pages/QuoteStartPage";
import CheckMyRate from "./pages/CheckMyRate";
import LoanInformation from "./pages/LoanInformation";
import RateResults from "./pages/RateResults";
import RefiBuddy from "./pages/RefiBuddy";
import GradeMyRate from "./pages/GradeMyRate";
import AdminPortal from "./pages/AdminPortal";
import ExampleResults from "./pages/ExampleResults";
import LoginPage from "./pages/LoginPage";
import CampaignRedirect from "./pages/CampaignRedirect";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import QuoteRequestGuard from "./components/QuoteRequestGuard";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    pingServer();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen bg-gray-50">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/quote-start" element={<QuoteStartPage />} />
              <Route
                path="/check-my-rate"
                element={
                  <QuoteRequestGuard>
                    <CheckMyRate />
                  </QuoteRequestGuard>
                }
              />
              <Route path="/loan-information" element={<LoanInformation />} />
              <Route path="/rate-results" element={<RateResults />} />
              <Route path="/should-i-refinance" element={<RefiBuddy />} />
              <Route path="/is-my-quote-good" element={<GradeMyRate />} />
              <Route path="/example-results" element={<ExampleResults />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/c/:campaignId" element={<CampaignRedirect />} />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminPortal />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
